<template>
  <div class="flex column" style="width: 100vm" v-title data-title="其他问题">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutStudentOther",
    data () {
      return{
        list: [
          {
            title: '什么是阅读字数呢？',
            detailTitle: '阅读字数是将用户的阅读量数字化。',
            detailTexts: [{title: '成功闯完一本书的所有关卡后，该书的总字数会在个人阅读数据中累加。'}]
          },
          {
            title: '如何修改头像、姓名、性别、生日、城市、学校、密码？',
            detailTexts: [{title: '点击“我的”页面，下滑至底部，选择“设置”进入设置页，选择“修改个人信息”，可修改个人信息。'},
              {title: '选择“修改密码”，通过输入手机号和验证码，可以修改密码。'}]
          },
          {
            title: '如何修改登录手机号？',
            detailTexts: [{title: '点击“我的”页面，下滑至底部，选择“设置”进入设置页，选择“修改手机号”。'}]
          },
          {
            title: '为什么班级里面存在重复的姓名？',
            detailTexts: [{title: '第1种情况，班级里有同名同姓的学生；'},{title: '第2中情况，同一个学生的几位家长都注册了账号，并以孩子的姓名加入了班级。'}]
          },
          {
            title: '为什么成功闯关以后字数没有增加？',
            detailTexts: [{title: '只有一本书的所有关卡都成功闯关阅读字数才会增加。'}]
          },
          {
            title: '为什么闯关的题目的在书中找不到闯关的答案？',
            detailTexts: [{title: '请确认阅读的纸质书与阅伴闯关书籍版本是否一致。'}]
          },
          {
            title: '为什么阅伴App找不到我想要闯关的书？',
            detailTexts: [{title: '1.阅伴APP顶部有搜索功能，使用书目搜索查找书籍；'},
              {title: '2.如果搜索不到书籍，可通过“缺书推荐”功能，向阅伴推荐你要闯关的书籍。'}]
          },
          {
            title: '手机不能获取验证码怎么办？',
            detailTexts: [{title: '阅伴App支持两种登录方式，一是手机号和短信验证码登录，二是手机号和密码的登录方式。如果遇到不方便接收验证码的情况下，可以使用密码登录（所以，一定要记得注册时设置的登录密码）。'}]
          },
          {
            title: '为什么孩子的阅芽总是不够？',
            detailTexts: [{title: '阅芽不足的原因：\n' +
                '读书不认真，导致每一关卡都要多次重复闯关。建议闯关之前先确认准备闯关对应的页码范围，认真阅读相应范围内的内容后立即开始闯关。闯关成功率提高，奖励阅芽数量会越来越多。'},
              {title: '快速获取阅芽：\n' +
                  '①在阅伴书店购书后，提交购书订单号，可以兑换阅芽。 ②购买会员通过签到，可以获得阅芽。 ③成功闯关可以获得阅芽奖励。 ④关注阅伴微信公众号参加阅伴活动。 ⑤老师赠送阅芽。⑥在阅芽农场中兑换阅芽。'}]
          },
          {
            title: '阅伴App为什么不能看书？',
            detailTexts: [{title: '您好，阅伴App目前仅提供闯关功能，如果想读书建议您在阅伴书店购买正版纸质书，购书还可以获得阅芽等奖励。'}]
          },
          {
            title: '为什么找不到自己的学校？',
            detailTexts: [{title: '您好，如果发现没有您自己的学校，您可以拨打电话联系我们。联系方式：'}]
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutStudentOther.vue